<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Danh sách lớp học"
          :link="[{ text: 'Danh sách lớp học', href: '../classes' }]"
        />
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex align-end" :class="{ 'flex-column align-center ': $vuetify.breakpoint.smAndDown }">
        <v-btn
          v-if="$auth.policies['add-new-class']"
          class="ml-6 text-uppercase"
          depressed
          color="primary"
          @click="createCoreClass = !createCoreClass"
          :block="$vuetify.breakpoint.smAndDown"
          :class="{ 'my-2 mr-6': $vuetify.breakpoint.smAndDown }"
        >
          <v-icon left>add</v-icon>
          Thêm lớp học
        </v-btn>
      </div>
    </div>

    <v-card v-if="$auth.role.type !== 'teacher'" outlined class="pa-6 mx-4 mb-6 elevation-0">
      <ClassFilter :windowWidth="windowWidth" @onFilterChanged="refresh" />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <ClassesDataTable ref="classesDataTable" />
    </v-card>

    <ExtraClassNewDialog :state="createExtraClass" @done="requestPageSettings({})" />
    <ClassNewDialog :state="createCoreClass" @done="requestPageSettings({})" style="margin: 0 20px"></ClassNewDialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

import Breadcrumbs from '@/components/layout/Breadcrumbs'
import ClassNewDialog from '@/modules/class/ClassNewDialog'
import ClassFilter from '@/modules/class/ClassFilter'
import moment from 'moment'
import get from 'lodash-es/get'
import utils from '@/plugins/utils'
import ClassesDataTable from '@/modules/class/ClassesDataTable.vue'
import ExtraClassNewDialog from '@/modules/class/ExtraClassNewDialog.vue'

export default {
  components: {
    ClassFilter,
    ClassNewDialog,
    Breadcrumbs,
    ClassesDataTable,
    ExtraClassNewDialog,
  },
  props: {},
  data() {
    return {
      draw: false,
      search: '',
      status: null,
      loading: false,
      statuses: [
        { text: 'Active', value: 'false' },
        { text: 'Blocked', value: 'true' },
      ],
      range: { from: null, to: null },
      previewUserId: null,
      ready: false,
      editClassId: '',
      dialog: false,
      selected: [],
      sendState: false,
      createCoreClass: false,
      createExtraClass: false,
      windowWidth: window.innerWidth,
    }
  },
  computed: {
    ...mapState('class', ['classData', 'classesData', 'classSearchParams']),
    ...mapGetters('class', ['classes']),
  },
  methods: {
    ...mapActions('class', [
      'fetchClasses',
      'setClass',
      'setClasses',
      'updateClasses',
      'removeClasses',
      'requestPageSettings',
    ]),

    async refresh(query) {
      this.$refs.classesDataTable.refresh(query)
    },
    getColor(classStatus) {
      switch (classStatus) {
        case 'running':
          return '#46BE8A'
        default:
          return 'primary'
      }
    },
    async exportExcel() {
      this.$loading.active = true
      try {
        const excelHeader = this.$refs.classesDataTable.headers.map(({ text, value }) => ({ text, value }))
        const filters = this.$options.filters
        // map on an array modify the original array => need to clone a new array
        const classes = await this.fetchClasses({ ...this.classSearchParams, _limit: -1, type: 'coreCurriculum' })
        const classesData = JSON.parse(JSON.stringify(classes))
        const data = classesData.map((item) => {
          item.type = filters.classType(item.type)
          item.division = filters.getDivision(item.division)
          item.headTeachers = filters.getTeacherNames(item)
          item.status = filters.classStatus(item.status)
          item.studentCount = filters.studentCounter(item.students)
          return item
        })
        utils.exportExcel(data, excelHeader, 'DanhSachLop')
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
  },
  filters: {
    studentCounter: (students) => {
      if (!students) {
        return 0
      }
      return students.filter((s) => s.status === 'active').length
    },
    classStatus: (status) => {
      if (status === 'opened') return 'Đang chờ'
      else if (status === 'running') return 'Đang Học'
      else if (status === 'done') return 'Kết Thúc'
      else return ''
    },
    getRoom: (item) => {
      return get(item, 'title', '')
    },
    getTeacherNames: (classData) => {
      return classData.headTeachers.map((teacher) => teacher.name).join(', ')
    },
    getDivision: (division) => {
      return division ? division.title : ''
    },
    displayDate: (date) => {
      if (date) return moment(date).format('DD/MM')
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    clearInterval(this.interval)
  },
}
</script>

<style scoped>
.chip-width {
  min-width: 82px;
  justify-content: center;
}
</style>
